
import Currency from '~/mixins/Currency.js'
import ProductNumber from '~/mixins/ProductNumber.js'

export default {
  mixins: [Currency, ProductNumber],

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      quantity: this.product.quantity,
    }
  },

  computed: {
    productPrice() {
      return this.$auth.$state.priceInclTax
        ? this.product.gross_price_total
        : this.product.priceTotal
    },
  },

  watch: {
    product: {
      handler() {
        this.quantity = this.product.quantity
      },

      deep: true,
      immediate: true,
    },
  },

  methods: {
    closeFavorites() {
      this.$store.commit('favorites/setClose')
    },

    async remove() {
      this.isLoading = true
      console.log(this.product)

      await this.$store.dispatch(
        'favorites/removeFromFavorites',
        this.product.entry_id
      )

      this.isLoading = false
    },
  },
}
